import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { EnrollmentHelper } from '@rd/helpers/enrollment.helper';
import { Enrollment } from '@rd/types/enrollment.type';

@Component({
  selector: 'rd-enrollment-form',
  templateUrl: './enrollment-form.component.html',
  styleUrls: ['./enrollment-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EnrollmentFormComponent implements OnInit {
  @Input() enrollments: Enrollment[];
  @Input() formGroupName: string;
  @Input() shouldAllowRedeemToOtherAccount: boolean;

  enrollmentForm: UntypedFormGroup;

  constructor(
    private enrollmentHelper: EnrollmentHelper,
    private rootFormGroup: FormGroupDirective,
  ) {}

  ngOnInit(): void {
    this.enrollmentForm = this.rootFormGroup.control.get(
      this.formGroupName,
    ) as UntypedFormGroup;
  }

  displayedAccountNumber(accountNumber: string): string {
    return this.enrollmentHelper.displayedAccountNumber(accountNumber);
  }

  productType(enrollment: Enrollment): string | undefined {
    return this.enrollmentHelper.productTypeFromProductCode(enrollment);
  }
}
